import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector, userCompaniesSelector } from '../Settings/store/SettingsSelectors'
import CompanyAdmin, { ICompanyAdminProps, ICompanyAdminDispatchProps } from './CompanyAdmin'
import { getCompanyInfo, updateCompanyInfo, setCompanyAdminSelectedCompanyId } from './store/CompanyAdminActions'
import {
  getCompanyAdminInfo,
  getCompanyAdminLoading,
  getCompanyAdminSaving,
  getCompanyAdminLastUpdated,
  getCompanyAdminSelectedCompanyId,
} from './store/CompanyAdminSelectors'

const mapStateToProps = (state: IGlobalState): ICompanyAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  userCompanies: userCompaniesSelector(state),
  companyInfo: getCompanyAdminInfo(state),
  loading: getCompanyAdminLoading(state),
  saving: getCompanyAdminSaving(state),
  lastUpdated: getCompanyAdminLastUpdated(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
})

const mapDispatchToProps: ICompanyAdminDispatchProps = {
  getCompanyInfo,
  updateCompanyInfo,
  setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAdmin)
